var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangularOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1014 17.5H8.8934C5.0347 17.5 3.10536 17.5 2.39437 16.2449C1.68337 14.9899 2.6702 13.3262 4.64385 9.99875L6.24787 7.29444C8.14372 4.09815 9.09165 2.5 10.4974 2.5C11.9031 2.5 12.8511 4.09814 14.7469 7.29443L16.351 9.99875C18.3246 13.3262 19.3114 14.9899 18.6004 16.2449C17.8894 17.5 15.9601 17.5 12.1014 17.5Z",
    stroke: "#F99E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5V11.25",
    stroke: "#F99E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.1602V14.1685",
    stroke: "#F99E00",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangularOuter);
export default __webpack_public_path__ + "static/media/alert-triangular-outer.d46b952b256011088b58a61b8e0f48c9.svg";
export { ForwardRef as ReactComponent };